import {GoogleOAuthProvider} from 'google-oauth-gsi';

export const googleProvider = new GoogleOAuthProvider({
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
});

export const initFbsdk = () => {
  var js,
      fjs = document.getElementsByTagName('script')[0];
  if (document.getElementById('facebook-jssdk')) {
    return;
  }
  js = document.createElement('script');
  js.id = 'facebook-jssdk';
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: process.env.VUE_APP_FACEBOOK_APP_ID,
      cookie: true,
      version: "v13.0"
    });
  };
};

export const initApple = () => {
  var js,
      ajs = document.getElementsByTagName('script')[0];
  if (document.getElementById('apple')) {
    return;
  }
  js = document.createElement('script');
  js.id = 'apple';
  js.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
  ajs.parentNode.insertBefore(js, ajs);
  js.onload = js.onreadystatechange = function () {
    window.AppleID.auth.init({
      clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
      scope: 'name email',
      redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URL,
      state: 'secret',
      usePopup: true,
    });
  };
};
